import { Wrapper } from "nystem-components";

const TextHref = ({ model, value }) =>
  value ? (
    <Wrapper renderAs="a" href={`${model.protocol}${value}`} className={model.className}>
      {value}
    </Wrapper>
  ) : null;

export default TextHref;
